import { useQuery } from 'react-query';
import { SapFlow } from '../../types/DataDelivery';
import { useAxiosInstance } from '../common';

const useSapConfig = (sapFlowId: string) => {
  const axios = useAxiosInstance();
  return useQuery(['sapFlow', sapFlowId], async () => {
    if (sapFlowId === null) return null;
    const result = await axios.get<SapFlow>('file_sapflow/' + sapFlowId);
    return result.data;
  });
};

export default useSapConfig;
